module.exports = __webpack_public_path__ + "img/age.156d5e21.svg";